import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { Link } from 'react-router-dom'; // Import Link from react-router-dom
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select

function Ledger() {
    const [dataBill, setDataBill] = useState([]);
    const [dataItem, setDataItem] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedOption, setSelectedOption] = useState('itemWise');
    const [customerId, setCustomer] = useState('');
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        fetchTableData();
        //fetchCustomerData();
    }, [isAuthenticated, companyId, token, logout]);

    //  Master Type

    const [masterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMaster, setSelectedMaster] = useState("");

    const fetchMasterType = async () => {
        try {

            const mtid = 0; // Replace with the actual ID you want to fetch
            const response = await fetchData('MasterTypeApi', `/${mtid}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleMasterTypeChange = (selectedOption) => {
        setSelectedMasterType(selectedOption);
        setSelectedMaster(selectedOption.value);
    };

    useEffect(() => {
        fetchMasterType();
    }, []);


    // Customers
    const [selectedMasterChild, setSelectedMasterChild] = useState("");
    const [selectedMasterChildlabel, setSelectedMasterChildlabel] = useState("");
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");

    const fetchCustomers = async () => {
        try {

            const response = await fetchData('CustomerApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setCustomerOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleCustomersChange = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
    };

    useEffect(() => {
        fetchCustomers();
    }, []);


    // Suppliers

    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState("");

    const fetchSupplier = async () => {
        try {

            const response = await fetchData('SupplierApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setSupplierOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleSupplierChange = (selectedOption) => {
        setSelectedSupplier(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
    };

    useEffect(() => {
        fetchSupplier();
    }, []);

    // Account Head

    const [accountheadOptions, setAccountHeadOptions] = useState([]);
    const [selectedAccountHead, setSelectedAccountHead] = useState(null);

    const fetchAccountHead = async () => {
        try {
            const response = await fetchData('AccountHeadApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setAccountHeadOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Account Head:', error);
        }
    };

    const handleAccountHeadChange = (selectedOption) => {
        setSelectedAccountHead(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
    };

    useEffect(() => {
        fetchAccountHead();
    }, []);

    // Bank

    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBank = async () => {
        try {
            const response = await fetchData('BankApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.accountName
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
        setSelectedMasterChild(selectedOption.value);
        setSelectedMasterChildlabel(selectedOption.label);
    };

    useEffect(() => {
        fetchBank();
    }, []);

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };

    const fetchTableData = async () => {

        setDataItem([])
        try {
            const response = await fetchData('ReportApi', `/Ledger/${companyId}/${selectedMaster}/${selectedMasterChild}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setDataItem(response.response_data);

            }
        } catch (error) {
            console.error('Error fetching Ledger Details:', error);
        }

    };

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setFromDate(selectedDate);
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        // Add validation if needed
        setToDate(selectedDate);
    };

    const hasReadReportPermission = permissions.includes('Read Reports');

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredDataBill = dataBill.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const filteredDataItem = dataItem.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const handleExportExcel = () => {
        const excelData = [];

        // Ensure selectedCustomer is handled properly
        const customerLabel = selectedMasterChildlabel ;
        // Add header row
        const headerCaption = [`Ledger for ${customerLabel} From : ${formatDate(fromDate)} To : ${formatDate(toDate)}`];
        excelData.push(headerCaption);

        const headerRow = ['Date', 'Description', 'Debit', 'Credit'];
        excelData.push(headerRow);

        // Add data rows
        filteredDataItem.forEach((rowData) => {
            const dataRow = [];
            if (rowData.description1 === 'Opening Balance' || rowData.description1 === 'Closing Balance' || rowData.description1 === 'Total') {
                dataRow.push('', rowData.description1, '', rowData.debit, rowData.credit);
            } else {
                dataRow.push(formatDate(rowData.date1), rowData.description11, rowData.debit, rowData.credit);
            }
            excelData.push(dataRow);
        });

        // Export logic (assuming you are using a library like 'xlsx' for Excel export)
        const worksheet = XLSX.utils.aoa_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Ledger');
        XLSX.writeFile(workbook, `Ledger_${customerLabel.replace(/\s/g, '_')}.xlsx`);
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) {
            console.error('Failed to open print window.');
            return;
        }

        // Ensure selectedCustomer is handled properly
        const customerLabel = selectedCustomer ? selectedCustomer.label : 'All Customers';
        const title = `Ledger for ${customerLabel} From: ${formatDate(fromDate)} To: ${formatDate(toDate)}`;

        // Begin writing to the print window
        printWindow.document.write('<html><head><title>' + title + '</title></head><body>');

        // Add title to the body as a heading
        printWindow.document.write(`<h5 style="font-family: Times New Roman; font-size: 22px;">${title}</h5>`);
        printWindow.document.write(`<h5 style="font-family: Times New Roman; font-size: 18px;">From: ${formatDate(fromDate)} To: ${formatDate(toDate)}</h5>`);

        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Date</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Description</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bill Amount</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Debit</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Credit</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        filteredDataItem.forEach((rowData, index) => {
            printWindow.document.write('<tr>');

            if (rowData.description === 'Opening Balance' || rowData.description === 'Closing Balance' || rowData.description === 'Total') {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;"></td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;">${rowData.description}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px; font-weight: bolder;"></td>`);
            } else {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${formatDate(rowData.date1)}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.description}</td>`);
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.billAmount}</td>`);
            }

            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.debit}</td>`);
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.credit}</td>`);

            printWindow.document.write('</tr>');
        });

        printWindow.document.write('</tbody>');
        printWindow.document.write('</table>');
        printWindow.document.write('</body></html>');

        printWindow.document.close();
        printWindow.print();
    };


    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>

            <h6 className="uppercase tracking-wide text-black font-serif flex-grow" style={{
                fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                color: 'black',
                marginTop: '10px',
            }}>
                Ledger
            </h6>
            <br />
            <div style={{ display: 'flex', flexWrap: 'nowrap', marginBottom: '16px', marginLeft: '5px' }}>
                <div style={{ flex: '2', maxWidth: '12%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="fromDate">
                        From Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                    />
                </div>

                <div style={{ flex: '2', maxWidth: '12%', marginLeft: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="toDate">
                        To Date
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                    />
                </div>

                <div style={{ flex: '3', maxWidth: '17%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px', marginLeft: '8px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="fromDate">
                        Party Type <span className="text-red-500">*</span>
                    </label>
                    <Select
                        value={selectedMasterType}
                        onChange={handleMasterTypeChange}
                        options={masterTypeOptions}
                        placeholder="Master Type"
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                zIndex: 1301,
                            }),
                            control: (provided) => ({
                                ...provided,
                            }),
                        }}
                        isSearchable
                    />
                </div>

                <div style={{ flex: '3', maxWidth: '25%', paddingRight: '8px', marginBottom: '0', marginTop: '-15px' }}>
                    {selectedMasterType.value === 1 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer">
                                Party Name <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedCustomer}
                                onChange={handleCustomersChange}
                                options={customerOptions}
                                placeholder="Select Customer"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                isSearchable
                            />
                        </div>
                    )}

                    {/* Supplier Dropdown */}
                    {selectedMasterType.value === 2 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer">
                                Party Name <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedSupplier}
                                onChange={handleSupplierChange}
                                options={supplierOptions}
                                placeholder="Select Supplier"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                isSearchable
                            />
                        </div>
                    )}

                    {/* Account Head Dropdown */}
                    {selectedMasterType.value === 3 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer">
                                Party Name <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedAccountHead}
                                onChange={handleAccountHeadChange}
                                options={accountheadOptions}
                                placeholder="Select Account Head"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                isSearchable
                            />
                        </div>
                    )}

                    {/* Bank Dropdown */}
                    {selectedMasterType.value === 4 && (
                        <div className="flex-1 w-2/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs  mb-2" htmlFor="customer">
                                Party Name <span className="text-red-500">*</span>
                            </label>
                            <Select
                                value={selectedBank}
                                onChange={handleBankChange}
                                options={bankOptions}
                                placeholder="Select Bank"
                                styles={{
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                isSearchable
                            />
                        </div>
                    )}
                </div>

                <Button
                    style={{
                        background: 'linear-gradient(to right, #A8A196,#A8A196)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '1.0%'

                    }}
                    onClick={fetchTableData}

                >
                    <RefreshIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Refresh</b>
                </Button>

                <Button
                    style={{
                        background: 'linear-gradient(to right, #4D455D,#4D455D)',
                        color: 'black',
                        fontWeight: 'bolder',
                        textTransform: 'none',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                        maxHeight: '30px',
                        marginLeft: '15px',
                        marginTop: '1.0%'

                    }}
                    onClick={handleExportExcel}

                >
                    <FeedIcon style={{ color: 'white', fontWeight: 'bolder' }} />
                    <b style={{ color: 'white' }}>Excel</b>
                </Button>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>

                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#102E50' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Description</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Debit</TableCell>
                                <TableCell sx={{ backgroundColor: '#102E50', borderBottom: '1px solid #ddd', fontSize: '12px', color: 'whitesmoke', textAlign: 'right', padding: '4px', fontWeight: 'bold', textTransform: 'uppercase' }}>Credit</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredDataItem.map((data, index) => (
                                <TableRow key={data.id} sx={data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? { backgroundColor: '#f0f0f0' } : null} style={{ textTransform: 'uppercase', fontSize: '12px' }}>

                                    {data.description === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? (

                                        <TableCell sx={{ padding: '5px', fontWeight: 'bolder' }}></TableCell>
                                    ) : (
                                        <TableCell sx={{ padding: '5px' }}>{formatDate(data.date1)}</TableCell>
                                    )}


                                    <TableCell
                                        sx={{
                                            //fontSize: '15px',
                                            height: '30px',
                                            padding: '7px',
                                            fontWeight:
                                                data.description1 === 'Opening Balance' ||
                                                    data.description1 === 'Closing Balance' ||
                                                    data.description1 === 'Total'
                                                    ? 'bolder'
                                                    : 'normal',
                                        }}
                                    >
                                        {data.tbl1 === 'Sale' ? (
                                            <a
                                                href={`/SaleDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'darkgreen' }}
                                            >
                                                {data.description1}
                                            </a>
                                        ) : data.tbl1 === 'SaleReturn' ? (
                                            <a
                                                href={`/SaleReturnDetails/${data.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{ color: 'red' }}
                                            >
                                                {data.description1}
                                            </a>
                                        )
                                            : data.tbl1 === 'Receipt UPI' ? (
                                                <a
                                                    href={`/ReceiptDetails/${data.id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ color: '#604652' }}
                                                >
                                                    {data.description1}
                                                </a>
                                            )
                                                : data.tbl1 === 'Receipt Cheque' ? (
                                                    <a
                                                        href={`/ReceiptDetails/${data.id}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ color: '#604652' }}
                                                    >
                                                        {data.description1}
                                                    </a>
                                                )
                                                    : data.tbl1 === 'Receipt Cash' ? (
                                                        <a
                                                            href={`/ReceiptDetails/${data.id}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ color: '#604652' }}
                                                        >
                                                            {data.description1}
                                                        </a>

                                                    )
                                                        : data.tbl1 === 'JournalCustomer1' ? (
                                                            <a
                                                                href={`/JournalEntryDetails/${data.id}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ color: 'darkorchid' }}
                                                            >
                                                                {data.description1}
                                                            </a>
                                                        )
                                                            : data.tbl1 === 'JournalCustomer2' ? (
                                                                <a
                                                                    href={`/JournalEntryDetails/${data.id}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{ color: 'darkorchid' }}
                                                                >
                                                                    {data.description1}
                                                                </a>
                                                            )
                                                                : data.tbl1 === 'JournalSupplier1' ? (
                                                                    <a
                                                                        href={`/JournalEntryDetails/${data.id}`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{ color: 'darkslategray' }}
                                                                    >
                                                                        {data.description1}
                                                                    </a>

                                                                )
                                                                    : data.tbl1 === 'JournalSupplier2' ? (
                                                                        <a
                                                                            href={`/JournalEntryDetails/${data.id}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{ color: 'darkslategray' }}
                                                                        >
                                                                            {data.description1}
                                                                        </a>
                                                                    )
                                                                        : data.tbl1 === 'JournalBank1' ? (
                                                                            <a
                                                                                href={`/JournalEntryDetails/${data.id}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ color: 'darkmagenta' }}
                                                                            >
                                                                                {data.description1}
                                                                            </a>
                                                                        )
                                                                            : data.tbl1 === 'JournalBank' ? (
                                                                                <a
                                                                                    href={`/JournalEntryDetails/${data.id}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    style={{ color: 'darkmagenta' }}
                                                                                >
                                                                                    {data.description1}
                                                                                </a>
                                                                            )
                                                                                : data.tbl1 === 'JournalAccountHead' ? (
                                                                                    <a
                                                                                        href={`/JournalEntryDetails/${data.id}`}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        style={{ color: 'darkmagenta' }}
                                                                                    >
                                                                                        {data.description1}
                                                                                    </a>
                                                                                )
                                                                                   
                                                                                        : data.tbl1 === 'Payment Cash' ? (
                                                                                            <a
                                                                                                href={`/PaymentDetails/${data.id}`}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                                style={{ color: 'darkviolet' }}
                                                                                            >
                                                                                                {data.description1}
                                                                                            </a>
                                                                                        )
                                                                                            : data.tbl1 === 'Payment Cheque' ? (
                                                                                                <a
                                                                                                    href={`/PaymentDetails/${data.id}`}
                                                                                                    target="_blank"
                                                                                                    rel="noopener noreferrer"
                                                                                                    style={{ color: 'darkviolet' }}
                                                                                                >
                                                                                                    {data.description1}
                                                                                                </a>
                                                                                            )
                                                                                                : data.tbl1 === 'Payment UPI' ? (
                                                                                                    <a
                                                                                                        href={`/PaymentDetails/${data.id}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        style={{ color: 'darkviolet' }}
                                                                                                    >
                                                                                                        {data.description1}
                                                                                                    </a>
                                                                                                )
                                                                                                    : data.tbl1 === 'Purchase' ? (
                                                                                                        <a
                                                                                                            href={`/PurchaseDetails/${data.id}`}
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            style={{ color: 'darkcyan' }}
                                                                                                        >
                                                                                                            {data.description1}
                                                                                                        </a>
                                                                                                    )
                                                                                                        : data.tbl1 === 'PurchaseReturn' ? (
                                                                                                            <a
                                                                                                                href={`/PurchaseReturnDetails/${data.id}`}
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                style={{ color: 'red' }}
                                                                                                            >
                                                                                                                {data.description1}
                                                                                                            </a>

                                                                                                        ) : (
                                                                                                            data.description1
                                                                                                        )}
                                    </TableCell>

                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.debit != null ? data.debit.toFixed(2) : ''}</TableCell>
                                    <TableCell sx={{ fontSize: '14px', height: '30px', padding: '5px', textAlign: 'right', fontWeight: data.description1 === 'Opening Balance' || data.description1 === 'Closing Balance' || data.description1 === 'Total' ? 'bolder' : 'normal' }}> {data.credit != null ? data.credit.toFixed(2) : ''}</TableCell>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>



            </div>
        </div>
    );
}

export default Ledger;
